import { createContext } from 'react'
import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'

import { ModalStore } from '../store/modal'

export const modalStore = new ModalStore()
export const ModalContext = createContext(modalStore)

export const ModalProvider = observer(({ children }: { children: ReactNode }) => {
  return <ModalContext.Provider value={modalStore}>{children}</ModalContext.Provider>
})
